import UpdateUserConfigurationJsonResponse from 'owa-service/lib/contract/UpdateUserConfigurationJsonResponse';
import updateUserConfiguration from 'owa-session-store/lib/services/updateUserConfiguration';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';

export default function updateEmojiMru(
    mruEmojis: string[]
): Promise<UpdateUserConfigurationJsonResponse> {
    return updateUserConfiguration('OWA.UserOptions', [
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['MruEmojis'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'StringArray',
                Value: mruEmojis,
            }),
        }),
    ]);
}
